import axios from "axios";
import { applyFreshPolicy } from "@/lib/cachePolicy";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "917297801755";

const api = applyFreshPolicy(axios.create({ baseURL: API }));

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tnt_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default api;

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

export const isPerKm = (p) => p?.pricing_type === "per_km";
// Price text for cards: "₹23/km" for per-km logistics, else flat price.
export const priceLabel = (p) => (isPerKm(p) ? `${inr(p.rate_per_km || 0)}/km` : inr(p.price));

export const waLink = (product, category, eventDate = "", quantity = 1, location = "", price = null) => {
  const priceLine = (price != null && Number.isFinite(Number(price)))
    ? `Price listed: ${inr(Number(price))}`
    : "";
  const msg = `Hello Tent N Tap,

I am interested in:

Product: ${product}
Category: ${category}${priceLine ? `\n${priceLine}` : ""}
Event Date: ${eventDate || "TBD"}
Quantity: ${quantity}
Location: ${location || "TBD"}

Please share availability and final pricing.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};

export const MAIN_CATEGORIES = [
  { key: "wedding", title: "Wedding" },
  { key: "once_a_year", title: "Once A Year" },
  { key: "tent_items", title: "Tent Items" },
  { key: "packages", title: "Packages" },
];
